import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintPricesInput,
    PrintPrices,
    UpdatePrintPricesInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintPricesService {
    private amplifyClient = generateClient();

    constructor() {}

    async listPrintPrices(): Promise<PrintPrices[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintPrices
                })
            ).data.listPrintPrices.items;
            if (data) return data as PrintPrices[];
        } catch (error) {
            console.error('Error finding PrintPrices:', error);
            return null;
        }
    }

    async getPrintPrices(id: string): Promise<PrintPrices> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPrintPrices,
                    variables: {
                        id
                    }
                })
            ).data.getPrintPrices;
            if (data) return data as PrintPrices;
        } catch (error) {
            console.error('Error finding PrintPrice:', error);
            return null;
        }
    }

    async createPrintPrices(
        input: CreatePrintPricesInput
    ): Promise<PrintPrices> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintPrices,
                    variables: {
                        input
                    }
                })
            ).data.createPrintPrices;
            if (date) return date as PrintPrices;
        } catch (error) {
            console.error('Error creating PrintPrices:', error);
            return null;
        }
    }
    async updatePrintPrices(
        input: UpdatePrintPricesInput
    ): Promise<PrintPrices> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintPrices,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintPrices;
            if (date) return date as PrintPrices;
        } catch (error) {
            console.error('Error updated PrintPrices:', error);
            return null;
        }
    }
}
